import { RadioButton } from "primereact/radiobutton";
import "./FormSection.scss";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useNegotiationsStore } from "../../../stores/negotiationsStore";
const FormSection: React.FC = () => {
	const {
		data,
		setBrand,
		setExtraGoals,
		setTargetSavings,
		setTargetSimulatedSavings,
	} = useNegotiationsStore();
	return (
		<>
			<div className="filter">
				<p className="filter-title">
					Form
					<span className="filter-subtitle">
						(complete below questionnaires)
					</span>
				</p>

				<div className="question-container">
					<div className="question-one questionpadding">
						<p className="question-label">
							1. Is this negotiation for private label or branded
							articles?
						</p>
						<div className="block">
							<RadioButton
								inputId="ingredient1"
								name="private"
								value="NO"
								onChange={(e) => setBrand(e.value)}
								checked={data.brand === "NO"}
							/>
							<label
								htmlFor="ingredient1"
								className="ml-2 question-label"
							>
								Private Label
							</label>
						</div>

						<div className="block">
							<RadioButton
								inputId="ingredient1"
								name="branded"
								value="YES"
								onChange={(e) => setBrand(e.value)}
								checked={data.brand === "YES"}
							/>
							<label
								htmlFor="ingredient1"
								className="ml-2 question-label"
							>
								Branded Articles
							</label>
						</div>
					</div>
					<div className="question-two questionpadding">
						<p className="question-label">
							2. Target for negotiations
						</p>
						<div className="inputblock">
							<div>
								<p className="label my-1">
									Enter target actual savings %
								</p>
								<InputText
									// it should accept decimal values

									value={String(data.target_savings ?? "")}
									onChange={(e) => {
										const n = e.currentTarget.value;
										setTargetSavings(n);
									}}
									className="p-1.5"
									style={{ width: "218px" }}
								/>
							</div>
							<div>
								<p className="label my-1">
									Enter target simulated savings %
								</p>
								<InputText
									value={String(
										data.target_simulated_savings ?? ""
									)}
									onChange={(e) => {
										const n = e.currentTarget.value;
										setTargetSimulatedSavings(n);
									}}
									className="p-1.5"
									style={{ width: "218px" }}
								/>
							</div>
						</div>
					</div>
					<div className="question-three questionpadding">
						<p className="question-label">
							3. Other category goals: (E.g. C&R)
						</p>

						<InputTextarea
							value={data.extra_goals}
							onChange={(e) =>
								setExtraGoals(e.currentTarget.value)
							}
							rows={5}
							cols={150}
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default FormSection;
